import { Component, OnInit } from '@angular/core';
import { ExpenseType } from '../expense-type';
import { ExpenseTypeService } from '../expense-type.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-expense-type',
  templateUrl: './expense-type.component.html',
  styleUrls: ['./expense-type.component.css'],
  providers: [ExpenseTypeService]
})
export class ExpenseTypeComponent implements OnInit {

  expenseTypes: ExpenseType[];	

  constructor(private expenseTypeService: ExpenseTypeService, private router: Router) { }

  ngOnInit() {
        this.expenseTypeService.getExpenseType().subscribe(response=> {this.expenseTypes=response['data'];});
  }

  clicked():void {
   		this.router.navigate(['/expense-type-crud']);
  }  

  clickedId(id: any){
    	 this.router.navigate(['/expense-type-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/expense_types/expense-type/expense-type.component.ts